import type { DataGridColumnDef, DataGridColumnDefOptions } from '../data-grid.type';
import { getColumnDefActions } from './actions';
import { cellTemplates } from './cells';
import { getColumnDefFormat } from './format';
import { getColumnDefSimpleType } from './simple';

export function getColumnDefCell<T>(col: DataGridColumnDef<T>, options: DataGridColumnDefOptions) {
  // Custom Cell Component takes precedence
  if (col.customCell) {
    return col.customCell;
  }

  // Pre-defined cell templates
  const predefinedCell = cellTemplates[col.type as keyof typeof cellTemplates];

  if (predefinedCell) {
    return predefinedCell(col, options);
  }
  
  // Actions Column
  if (col.type === 'actions' && col.actions) {
    return getColumnDefActions(col);
  }
  
  // Formatted Column
  if ('format' in col && col.format) {
    return getColumnDefFormat(col);
  }
  
  // Simple Type Column
  return getColumnDefSimpleType(col, options);
}
